import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}
export function captcha() {
  return request({
    url: '/auth/captcha',
    method: 'get'
  })
}

export function getInfo() {
  return request({
    url: '/auth/info',
    method: 'get',
    silent: true
  })
}

export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}
